import { getCategories } from "@/core/lib/api/main/main-shop-product";
import { CategoryNav } from "../elements/Product/CategoryNav";
import { isStockIgnored } from "@/core/lib/api/main/stock";

export default async function CategoryNavSection({
  activeSlug,
}: {
  activeSlug: string;
}) {
  const categories = await getCategories();
  // وقتی نمایش ناموجودی در تنظیمات غیرفعال است، فیلتر «موجود در انبار» هم نمایش داده نشود
  const hideAvailabilityFilter = await isStockIgnored();
  return (
    <CategoryNav
      categories={categories.data}
      activeSlug={activeSlug}
      hideAvailabilityFilter={hideAvailabilityFilter}
    />
  );
}
